
<section class="register-user__calendar">
  <header class="calendar__header">
    <h2 class="calendar__title ci-heading-h2-s-bold">
      {{ 'Datos del viaje' | translate }}
    </h2>
    
   @if (isInvalidField()) {
      <span class="ci-paragraph-p1-regular calendar__error-text">
        {{ 'Las fechas de inicio y fin son obligatorias' | translate }}
      </span>
    } @else {
      <span class="ci-paragraph-p1-regular calendar__subtitle">
        {{ 'Indica la fecha de tu viaje' | translate }}
        <strong>({{ 'obligatorio' | translate }})</strong>
      </span>
    }
  </header>
  
  <main class="calendar__main">
    <mat-calendar 
      #calendarRef
      [minDate]="minDate" 
      [(selected)]="selectedDateRange" 
      (selectedChange)="rangeChanged($event)" 
    />
  </main>
  
  <hr class="calendar__divider calendar__divider--mobile" />

  <footer class="calendar__footer">
    <div class="footer__start-date">
      <span class="ci-paragraph-p1-regular start-date__label">
        {{ 'Fecha de inicio' | translate }}
      </span>
      
      <span class="ci-heading-h5-bold start-date__value" [innerHTML]="getDate('start')">
        <!-- {{ getDate('start') }} -->
      </span>
    </div>
    
    <span class="footer__divider"></span>
    
    <div class="footer__end-date">
      <span class="ci-paragraph-p1-regular end-date__label">
        {{ 'Fecha de fin' | translate }}
      </span>

      <span class="ci-heading-h5-bold end-date__value" [innerHTML]="getDate('end')">
        <!-- {{ getDate('end') }} -->
      </span> 
    </div>
  </footer>
</section>

